var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-processes-page" }, [
    _c(
      "div",
      { staticClass: "o-width-limiter" },
      [
        _c("div", { staticClass: "o-grid" }, [
          _c(
            "div",
            {
              staticClass: "o-grid__column",
              attrs: { "data-size": "sm:12 md:8 lg:8" }
            },
            [
              _c(
                "h1",
                { staticClass: "t-text-style-alpha t-margin-bottom-s" },
                [
                  _vm.appCustomerLogotype
                    ? _c("img", {
                        staticClass: "customer-image",
                        attrs: {
                          src: _vm.appCustomerLogotype,
                          alt: "",
                          width: "200",
                          height: "50"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "customer-name",
                    domProps: { innerHTML: _vm._s(_vm.appTitle) }
                  })
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "o-grid__column" }, [
            _c(
              "button",
              {
                staticClass: "c-button c-button--linkstyle c-button--reset",
                attrs: { type: "button" },
                on: { click: _vm.exportPdfs }
              },
              [
                _c("vue-icon", { attrs: { name: "file" } }),
                _vm._v(" "),
                _c("span", { staticClass: "c-process-item__button" }, [
                  _vm._v("Generera PDF")
                ])
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("processes-data-provider", {
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function(dataProvider) {
                return _c(
                  "div",
                  {},
                  [
                    dataProvider.loading
                      ? _c("div", { staticClass: "c-spinner" })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("processes", {
                      attrs: {
                        processes: dataProvider.processes,
                        "original-process-ids": dataProvider.originalProcessIds
                      },
                      on: { delete: dataProvider.delete }
                    })
                  ],
                  1
                )
              }
            }
          ])
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }